function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{clip-path:url(#a);}.c{clip-path:url(#b);}.d{fill:#10cd77;}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  x: 25.6,
  y: 25.6,
  width: 256,
  height: 292
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M234.9,170.18l26.28-26.1a69.15,69.15,0,0,0,0-98.13,70.29,70.29,0,0,0-98.79,0l-9.56,9.5A69.82,69.82,0,0,0,95.41,25.6C56.87,25.6,25.6,56.66,25.6,95V245.29c0,38.28,31.27,69.34,69.81,69.34a69.82,69.82,0,0,0,57.42-29.85l9.56,9.5a70.28,70.28,0,0,0,98.79,0,69.15,69.15,0,0,0,0-98.13l-26.28-26Z"
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "876hqgu2-kickstarter-logo-k-green");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "c"
}, /*#__PURE__*/React.createElement("rect", {
  className: "d",
  width: 307.2,
  height: 340.23
}));

var SvgKsLogo = function SvgKsLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 307.2 340.23",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKsLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ks-logo.3c2561c8.svg";
export { ForwardRef as ReactComponent };